import {
  ref,
  Ref,
  useRoute,
  useRouter,
  computed,
} from '@nuxtjs/composition-api';
import { Slugs } from '@/modules/About/constants/Routing';
import { AboutTabValue } from '@/modules/About/constants/Pages';

let isInitialized;
let router;
let route;
const isReady: Ref<boolean> = ref(false);
const header = ref();

export interface IPage {
  id: string;
  url: string;
  name: string;
}

export const pages: IPage[] = [
  {
    id: AboutTabValue.ABOUTBAMBEE,
    url: Slugs[AboutTabValue.ABOUTBAMBEE],
    name: 'About Bambee',
  },
  {
    id: AboutTabValue.LEADERSHIP,
    url: Slugs[AboutTabValue.LEADERSHIP],
    name: 'Leadership',
  },
  {
    id: AboutTabValue.INVESTORS,
    url: Slugs[AboutTabValue.INVESTORS],
    name: 'Investors',
  },
  {
    id: AboutTabValue.TEAMS,
    url: Slugs[AboutTabValue.TEAMS],
    name: 'Teams',
  },
  {
    id: AboutTabValue.CULTURE,
    url: Slugs[AboutTabValue.CULTURE],
    name: 'Culture',
  },
  // <--BEEREX-439-->
  // {
  //   id: AboutTabValue.BENEFITS,
  //   url: Slugs[AboutTabValue.BENEFITS],
  //   name: 'Benefits',
  // },
  {
    id: AboutTabValue.HRMANAGERS,
    url: Slugs[AboutTabValue.HRMANAGERS],
    name: 'HR Managers',
  },
  {
    id: AboutTabValue.CAREERS,
    url: Slugs[AboutTabValue.CAREERS],
    name: 'Careers',
  },
];

const pageIndex = computed(() => {
  return {
    label:
      pages.find((p) => p.name === route?.value?.path.split('/')[2])?.name ||
      'About Bambee',
    value:
      pages.find((p) => p.id === route?.value?.path.split('/')[2])?.id ||
      'about',
  };
});

const goToPage = (pageValue: AboutTabValue): void => {
  const match = pages.find((p) => p.id === pageValue);
  if (route.value?.fullPath !== match?.url) {
    router.push(match?.url);
  }
};

// Set up the hook with all the initial calls needed to populate the state
const setupHook = (): void => {
  isInitialized = true;
  router = useRouter();
  route = useRoute();

  isReady.value = true;
};

const useAbout = () => {
  if (!isInitialized) {
    setupHook();
  }

  return {
    isReady,
    goToPage,
    header,
    pageIndex,
  };
};

export default useAbout;
